var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form-group filterfield",
      attrs: {
        id: _vm.htmlId,
        "data-filterfield-type": _vm.definition.componentName,
      },
    },
    [
      _vm.showLabel
        ? _c(
            "label",
            { staticClass: "col-xs-12", attrs: { for: _vm.inputId } },
            [
              _vm._v(_vm._s(_vm.displayName) + " "),
              _c("Debug", [
                _vm._v(
                  "(id: " +
                    _vm._s(_vm.id) +
                    " [" +
                    _vm._s(_vm.fields.low) +
                    " - " +
                    _vm._s(_vm.fields.high) +
                    "])"
                ),
              ]),
            ],
            1
          )
        : _c("Debug", [
            _c("label", { staticClass: "col-xs-12" }, [
              _vm._v(
                "(id: " +
                  _vm._s(_vm.id) +
                  " [" +
                  _vm._s(_vm.fields.low) +
                  " - " +
                  _vm._s(_vm.fields.high) +
                  "])"
              ),
            ]),
          ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-4" }, [
        _c("input", {
          staticClass: "form-control",
          attrs: {
            type: "number",
            placeholder: "From",
            autocomplete: "off",
            id: _vm.inputId + "_lower",
          },
          domProps: { value: _vm.value.low },
          on: {
            input: function ($event) {
              return _vm.e_input(
                Object.assign({}, _vm.value, { low: $event.target.value })
              )
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-4" }, [
        _c("input", {
          staticClass: "form-control",
          attrs: {
            type: "number",
            placeholder: "To",
            autocomplete: "off",
            id: _vm.inputId + "_upper",
          },
          domProps: { value: _vm.value.high },
          on: {
            input: function ($event) {
              return _vm.e_input(
                Object.assign({}, _vm.value, { high: $event.target.value })
              )
            },
          },
        }),
      ]),
      _vm._v(" "),
      !_vm.fields.mode
        ? _c(
            "div",
            {
              staticClass: "btn-group col-xs-12",
              staticStyle: { "margin-top": "12px" },
            },
            _vm._l(_vm.modes, function (mode) {
              return _c(
                "button",
                {
                  key: mode.value,
                  class: [
                    "btn btn-default",
                    { active: _vm.value.mode === mode.value },
                  ],
                  attrs: {
                    type: "button",
                    value: mode.value,
                    title: mode.title,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.e_input(
                        Object.assign({}, _vm.value, { mode: mode.value })
                      )
                    },
                  },
                },
                [_vm._v(_vm._s(mode.label))]
              )
            }),
            0
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }